var map = {
	"./hong-kong/config.json": [
		33732,
		792
	],
	"./hong-kong/terms_en.json": [
		85021,
		792
	],
	"./hong-kong/terms_zh.json": [
		53816,
		792
	],
	"./taiwan/config.json": [
		30622,
		792
	],
	"./taiwan/terms.json": [
		98023,
		792
	],
	"./taiwan/test/chart-data-example1.json": [
		66880,
		792
	],
	"./taiwan/test/chart-data-example2.json": [
		21309,
		792
	],
	"./taiwan/test/dividend-alone-table-example.json": [
		87826,
		792
	],
	"./taiwan/test/dividend-data-example.json": [
		93890,
		792
	],
	"./taiwan/test/fund-detail-document-example.json": [
		94413,
		792
	],
	"./taiwan/test/fund-item-FF-example.json": [
		4298,
		792
	],
	"./taiwan/test/fund-item-onshore-example.json": [
		89274,
		792
	],
	"./taiwan/test/holdings-data-example.json": [
		41155,
		792
	],
	"./taiwan/test/holdings-data-gfstx-example.json": [
		79916,
		792
	],
	"./taiwan/test/terms-example.json": [
		11827,
		792
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 39738;
module.exports = webpackAsyncContext;